import { boot } from 'quasar/wrappers';
import { Pages } from 'src/model/pages';
import { Billing } from 'src/model/billing';
import { Db } from 'src/model/db/db';
import { Factory } from 'components/factory/factory';
import Page from 'src/pages/Page';
import PageTabs from 'src/pages/PageTabs';
import _ from 'lodash';

// Стандартные (встроенные) страницы
import PageBio from 'src/pages/default/PageBio';
import PageLogin from 'src/pages/default/PageLogin';
import PageConfirmTel from 'src/pages/default/PageConfirmTel';
import PageConfirmVk from 'src/pages/default/PageConfirmVk';
import PageCourse from 'src/pages/default/PageCourse';
import PageTask from 'src/pages/default/PageTask';
import PageTasks from 'src/pages/default/PageTasks';
import PageCertificate2 from 'pages/default/PageCertificate2';
import PageBuyCourse from 'pages/default/PageBuyCourse';
import PagePayForCourse from 'pages/default/PagePayForCourse';
import PageBuySuccess from 'pages/default/PageBuySuccess';
import PageMyCourses from 'pages/default/PageMyCourses';
import PageSubscription from 'pages/default/PageSubscription';
import PageBuySubscription from 'pages/default/PageBuySubscription';

// Визуальные компоненты
import Button from 'src/components/ui/Button';
import Text from 'src/components/ui/Text';
import HTML from 'src/components/ui/HTML';
import Image from 'src/components/ui/Image';
import Space from 'src/components/ui/Space';
import Video from 'src/components/ui/Video';
import Container from 'src/components/ui/Container';
import TextInput from 'components/ui/TextInput';
import Poll from 'components/ui/Poll';
import DefaultButton from 'src/components/ui/common/DefaultButton';
import QCustomCheckbox from 'src/components/ui/QCustomCheckbox';
import NextCheckbox1 from 'components/next/NextCheckbox1';
import NextButton2 from 'components/next/NextButton2';

// Эмиттеры адаптогена
import mitt from 'mitt';

// import VueSocketIO from 'vue-3-socket.io';

export default boot(async ({ app }) => {
    window._ = _;

    /*
    const socketIo = new VueSocketIO({
        debug: true,
        connection: 'ws://146.120.224.57:53219',
    });
    app.use(socketIo);
     */

    // Навигация по страницам
    app.config.globalProperties.$pages = new Pages(app.config.globalProperties);
    // Биллинг
    app.config.globalProperties.$billing = new Billing(app.config.globalProperties);
    // Фабрика компонент
    app.config.globalProperties.$factory = new Factory(app.config.globalProperties);
    // Провайдер данных
    app.config.globalProperties.$db = new Db(app);
    app.config.globalProperties.$host = () => {
        let protocol = 'http://';
        if (window.location.hostname === 'sot.club') {
            protocol = 'https://';
        }
        return `${protocol}${window.location.hostname}`;
    };

    app.config.globalProperties.$q.isMobile = app.config.globalProperties.$q.platform.is.mobile;

    app.config.globalProperties.$emitter = mitt();

    // Страница
    app.component('Page', Page);

    // Встроенные страницы
    app.component('PageBio', PageBio);
    app.component('PageLogin', PageLogin);
    app.component('PageConfirmTel', PageConfirmTel);
    app.component('PageConfirmVk', PageConfirmVk);
    app.component('PageCourse', PageCourse);
    app.component('PageTask', PageTask);
    app.component('PageTasks', PageTasks);
    app.component('Tabs', PageTabs);
    app.component('PageCertificate2', PageCertificate2);
    app.component('PageBuyCourse', PageBuyCourse);
    app.component('PagePayForCourse', PagePayForCourse);
    app.component('PageBuySuccess', PageBuySuccess);
    app.component('PageMyCourses', PageMyCourses);
    app.component('PageSubscription', PageSubscription);
    app.component('PageBuySubscription', PageBuySubscription);

    // Кнопка
    app.component('Button', Button);
    app.component('DefaultButton', DefaultButton);
    // Текст
    app.component('Text', Text);
    // HTML
    app.component('Html', HTML);
    // Картинка
    app.component('Image', Image);
    // Отступ - растягиват по вертикали пространство
    app.component('Space', Space);
    // Видео
    app.component('Video', Video);
    // Контейнер
    app.component('Container', Container);
    app.component('Textinput', TextInput);
    app.component('Poll', Poll);
    app.component('QCustomCheckbox', QCustomCheckbox);
    app.component('NextCheckbox1', NextCheckbox1);
    app.component('NextButton2', NextButton2);
});

window.intervals = {};
window.intervals.delims = ['-', '...', '..'];
window.intervals.has = (text) => {
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        if (text?.includes(delims[i])) {
            return true;
        }
    }
    return false;
};

window.intervals.split = (text) => {
    if (!text) { return undefined; }
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        const delim = delims[i];
        if (text?.includes(delim)) {
            return text.split(delim).map((j) => (j || '').trim());
        }
    }
    return [text];
};

window.intervals.delim = (text) => {
    if (!text) { return undefined; }
    const { delims } = window.intervals;
    for (let i = 0; i < delims.length; i += 1) {
        const delim = delims[i];
        if (text?.includes(delim)) {
            return delim;
        }
    }
    return undefined;
};
